import type { CoachResponse } from '@on3/api';
import { useSite } from '@on3/ui-lib/index';
import { currencyFormatterCommas } from '@on3/ui-lib/utils/formatters';
import { slugify } from '@on3/ui-lib/utils/slugify';
import { TeamAvatar } from 'components/Image/TeamAvatar';
import { getSourceUrl } from 'components/Nil/DealTracker/DealTrackerItems/helper';
import { TextLink } from 'components/UI/Link/TextLink';
import { Text } from 'components/UI/Typography/Text';

import styles from './PositionInfo.module.scss';

export const PositionInfo = ({ data }: { data: CoachResponse }) => {
  const {
    organization,
    primaryPosition,
    salary,
    defaultSport,
    salaryUrl,
    secondaryPosition,
  } = data || {};

  const { slug, assetUrl } = organization ?? {};
  const { defaultYears } = useSite();
  const { footballSeasonYear, footballRecruitingYear } = defaultYears;
  const sluggedSport = slugify(defaultSport?.name || 'football');
  const hasJob = !!organization;

  return (
    <div className={styles.infoContainer}>
      <div className={styles.infoItem}>
        {hasJob && (
          <TextLink
            href={`/college/${slug}/${sluggedSport}/${footballRecruitingYear}/industry-comparison-commits/`}
          >
            <TeamAvatar
              className={styles.teamLogo}
              height={100}
              slug={slug}
              src={assetUrl}
              width={100}
            />
          </TextLink>
        )}

        <div className={styles.salaryContainer}>
          <Text className={styles.positionDescription} variant="subtitle1">
            Current Position
          </Text>
          <Text className={styles.position} variant="subtitle1">
            {primaryPosition?.name ?? 'Unemployed'}
          </Text>
          {secondaryPosition && (
            <Text className={styles.secondaryName}>
              {secondaryPosition?.name}
            </Text>
          )}
          {salary && hasJob && (
            <div className={styles.salaryWrapper}>
              <Text className={styles.salaryName} variant="subtitle1">
                Salary
              </Text>
              <TextLink
                className={styles.salary}
                href={`/db/coach/salaries/${sluggedSport}/${footballSeasonYear}/`}
                underline="none"
              >
                {currencyFormatterCommas(salary)}
              </TextLink>
              <span />
            </div>
          )}
          {salaryUrl && hasJob && (
            <TextLink
              className={styles.source}
              href={salaryUrl}
              target="_blank"
              underline="none"
              variant="subtitle1"
            >
              {getSourceUrl(salaryUrl ?? '', '#6f747b')}
              Source
            </TextLink>
          )}
        </div>
      </div>
      {hasJob && (
        <TextLink
          className={styles.salaryIndex}
          href={`/db/coach/salaries/${sluggedSport}/${footballSeasonYear}/`}
          underline="none"
          variant="subtitle1"
        >
          Coach Salaries Index
        </TextLink>
      )}
    </div>
  );
};
